export const getCaretPosition = (element: Element | Window) => {
  let pos = 0
  let sel: TextSelection = null
  if (!element) return pos
  const doc = (element as Node).ownerDocument || (element as Window).document
  const win: Window = doc.defaultView || (doc as unknown as { parentWindow: Window }).parentWindow
  if (typeof win.getSelection != 'undefined') {
    const modernSelection = win.getSelection()
    if (modernSelection.rangeCount > 0) {
      const range = win.getSelection().getRangeAt(0)
      const preCaretRange = range.cloneRange()
      preCaretRange.selectNodeContents(element as Node)
      preCaretRange.setEnd(range.endContainer, range.endOffset)
      pos = preCaretRange.toString().length
    }
  } else if ((sel = (doc as unknown as { selection: TextSelection }).selection) && sel.type != 'Control') {
    const textRange = sel.createRange()
    const preCaretTextRange = doc.body.createTextRange()
    preCaretTextRange.moveToElementText(element as Element)
    preCaretTextRange.setEndPoint('EndToEnd', textRange)
    pos = preCaretTextRange.text.length
  }
  return pos
}

export const setCaretPosition = (element: HTMLElement, position: number) => {
  if (
    element &&
    element === document.activeElement &&
    element.childNodes &&
    element.childNodes[0] &&
    position <= (element.childNodes[0] as Text).length
  ) {
    const range = document.createRange()
    const selection = window.getSelection()
    range.setStart(element.childNodes[0], position)
    range.collapse(true)
    selection.removeAllRanges()
    selection.addRange(range)
    element.focus()
  }
}
